const rootActionPath = 'core/ButtonUninstall';

export const BUTTON_UNINSTALL_VIEW = `${rootActionPath}/VIEW`;
